module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-01"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "hidden-xs-only ",
    attrs: {
      "xs12": "",
      "sm2": "",
      "md2": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 300,
      "imaSrc": "design/banco1-1-3",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "Existen diferentes tipos de gastos",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("Existen diferentes"), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" tipos de gastos")])], 2)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Existen diferentes tipos de gastos',
      "videoEmbed": "ADMINISTRACIONDINERO28DiferentesTiposDeGastosa.mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', [_vm._v("Pase el cursor o dé enter sobre cada tipo de gasto para descubrir su definición")])])], 1), _vm._v(" "), _c('button-expand-cont', {
    staticClass: "animated fadeInUp dura_2",
    attrs: {
      "contenidos": _vm.contenidos
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-578b05e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-28.vue
// module id = 999
// module chunks = 1